"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import { Link } from "@nxt-costco-com/forge-components";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../Analytics/index.js";
import { AdSetTitle } from "../../AdSet/AdSetTitle.js";
import { ProductTileCarouselClient } from "../ProductTileCarousel/ProductTileCarouselClient.js";
import { AdSetContainerStyles } from "../styles.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { COMPONENT_NAME } from "./constants.js";
import { getLocalizedCriteoRenderingValue, useCriteoAnalytics } from "./utils.js";
import { ButterflyDisplayContainer, ButterflyDisplayImage, ButterflyDisplayCarouselContainer } from "./styles.js";
function CriteoButterflyDisplay({
  // eslint-disable-next-line react/prop-types
  a11yCriteo,
  // eslint-disable-next-line react/prop-types
  contentStackEntry = {},
  // eslint-disable-next-line react/prop-types
  locale,
  // eslint-disable-next-line react/prop-types
  titleProps,
  // eslint-disable-next-line react/prop-types
  products,
  // eslint-disable-next-line react/prop-types
  placement,
  // eslint-disable-next-line react/prop-types
  ParentSKUs,
  // eslint-disable-next-line react/prop-types
  productTileSx,
  sx = {}
}) {
  var _a, _b;
  const { bdWHNumber } = useCriteo();
  const { isTablet, isDesktop, isMobile } = useCheckScreen();
  const { criteo_placement_name } = (contentStackEntry == null ? void 0 : contentStackEntry.third_party_curation) || {};
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = (contentStackEntry == null ? void 0 : contentStackEntry.product_display_style) || {};
  const analytics = useCriteoAnalytics({ placement, products });
  if (!products || !placement) return null;
  const testId = `${COMPONENT_NAME}_${criteo_placement_name}`;
  const renderingInformation = placement == null ? void 0 : placement.rendering;
  const renderingType = isDesktop || isTablet ? "desktop" : "mobile";
  const bannerImageSrc = getLocalizedCriteoRenderingValue(
    renderingInformation,
    `${renderingType}_background_image`,
    locale
  );
  const bannerImageAltText = getLocalizedCriteoRenderingValue(
    renderingInformation,
    `${renderingType}_background_image_alt_text`,
    locale
  );
  const borderColor = getLocalizedCriteoRenderingValue(
    renderingInformation,
    `border_color`,
    locale
  );
  const bannerBackgroundColor = getLocalizedCriteoRenderingValue(
    renderingInformation,
    `background_color`,
    locale
  );
  const heightOffset = show_action_button ? 40 : 0;
  let maxProductTileImageHeight = `${250 - heightOffset}px`;
  if (isTablet) {
    maxProductTileImageHeight = `${225 - heightOffset}px`;
  } else if (isMobile) {
    maxProductTileImageHeight = `${250 - heightOffset}px`;
  }
  const redirectURL = getLocalizedCriteoRenderingValue(
    renderingInformation,
    `optional_footer_redirect_url`,
    locale
  ) || getLocalizedCriteoRenderingValue(
    renderingInformation,
    `web_redirect_URL`,
    locale
  );
  const MediaContainer = redirectURL ? ({ sx: sx2, children }) => {
    var _a2;
    return /* @__PURE__ */ jsx(
      Link,
      {
        dataPrivate: (_a2 = contentStackEntry == null ? void 0 : contentStackEntry.enable_url_tracking) == null ? void 0 : _a2.disable_third_party_tracking,
        href: redirectURL,
        sx: sx2,
        children
      }
    );
  } : ({ sx: sx2, children }) => /* @__PURE__ */ jsx(CostcoBox, { sx: sx2, children });
  return /* @__PURE__ */ jsxs(CostcoBox, { sx: { minWidth: "100%", ...AdSetContainerStyles, ...sx }, children: [
    /* @__PURE__ */ jsx(AdSetTitle, { ...titleProps }),
    /* @__PURE__ */ jsxs(
      ButterflyDisplayContainer,
      {
        borderColor,
        "data-testid": testId,
        isMobile,
        children: [
          /* @__PURE__ */ jsx(
            MediaContainer,
            {
              sx: {
                background: bannerBackgroundColor,
                borderBottomLeftRadius: !isMobile ? "10px" : void 0,
                borderTopLeftRadius: "10px",
                borderTopRightRadius: isMobile ? "10px" : void 0,
                display: "flex",
                flex: 1,
                justifyContent: "center",
                minHeight: isDesktop ? "100%" : void 0,
                minWidth: !isMobile ? `180px` : void 0,
                overflow: "hidden",
                width: !isMobile ? `50%` : "100%"
              },
              children: /* @__PURE__ */ jsx(
                Analytics,
                {
                  analyticData: {
                    adItem: {
                      style: "banner",
                      title: bannerImageAltText
                    }
                  },
                  children: /* @__PURE__ */ jsx(
                    ButterflyDisplayImage,
                    {
                      alt: bannerImageAltText,
                      isMobile,
                      src: bannerImageSrc
                    },
                    bannerImageSrc
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(ButterflyDisplayCarouselContainer, { isMobile, children: /* @__PURE__ */ jsx(
            Analytics,
            {
              analyticData: {
                adItem: {
                  style: "carousel",
                  title: (_a = contentStackEntry == null ? void 0 : contentStackEntry.ad_set_heading_and_costco_url) == null ? void 0 : _a.title,
                  type: "product"
                },
                doNotTrack: (_b = contentStackEntry == null ? void 0 : contentStackEntry.enable_url_tracking) == null ? void 0 : _b.disable_third_party_tracking,
                title: contentStackEntry.title
              },
              children: /* @__PURE__ */ jsx(
                ProductTileCarouselClient,
                {
                  bdWHNumber,
                  containerSx: {
                    marginBottom: 0,
                    maxWidth: isMobile ? "100%" : void 0,
                    padding: !isMobile ? `${SpaceMd}` : void 0
                  },
                  maxProductTileImageHeight,
                  maxProductTileImageWidth: isMobile ? "40%" : void 0,
                  minProductTileImageWidth: isMobile ? "40%" : void 0,
                  productTileNumberSeparator: (
                    // eslint-disable-next-line react/prop-types
                    a11yCriteo == null ? void 0 : a11yCriteo.a11yProductTileSeperator
                  ),
                  productTileSx: {
                    ...productTileSx,
                    marginBottom: 0,
                    padding: 1
                  },
                  analytics,
                  ariaLabel: a11yCriteo == null ? void 0 : a11yCriteo.a11yTitle,
                  criteoDataSourceAttr: true,
                  hideReviewStarValue: true,
                  inventoryAware: inventory_aware_listings,
                  isHorizontal: isMobile,
                  itemNumbers: ParentSKUs,
                  locale,
                  maxSlides: 1,
                  navigationButtonBottomOffset: "70%",
                  navigationButtonsBottomAlign: isMobile,
                  navigationButtonsMobileDisplay: isMobile,
                  productTileMaxLineNumber: 2,
                  showActionButton: show_action_button,
                  showReviews: show_reviews,
                  showSlideNumber: !isMobile,
                  testId,
                  variant: product_card_display_style,
                  product_tile_data_source,
                  isCriteo: true
                }
              )
            }
          ) })
        ]
      }
    )
  ] });
}
CriteoButterflyDisplay.displayName = COMPONENT_NAME;
export {
  CriteoButterflyDisplay
};
